import * as React from 'react';

import { CSATChromePreview } from 'components/settings/components/sections/satisfaction/components/ChatCSAT/CSATChromePreview/CSATChromePreview';
import { CSATWidgetMessage } from 'components/settings/components/sections/satisfaction/components/ChatCSAT/CSATWidgetMessage/CSATWidgetMessage';
import {
  CSATRatingStyle,
  RatingPreview,
} from 'components/settings/components/sections/satisfaction/components/ChatCSAT/RatingPreview/RatingPreview';

type Props = {
  className?: string;
  question: string;
  ratingStyle: CSATRatingStyle;
};

export const CSATRatingPreview: React.FunctionComponent<Props> = ({
  className,
  question,
  ratingStyle,
}) => {
  return (
    <CSATChromePreview className={className}>
      <CSATWidgetMessage>
        <RatingPreview question={question} ratingStyle={ratingStyle} />
      </CSATWidgetMessage>
    </CSATChromePreview>
  );
};
